import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { authreducers} from "../redux/reducers/authreducers";
import { masterreducers } from "../redux/reducers/masterreducers";
import { scalereducers } from "../redux/reducers/scalereducers";

export const store = configureStore({
    reducer: {
      auth: authreducers,
      master: masterreducers,
      scale: scalereducers,
    },
  });
// export type of root state from reducers
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;